import { Router } from "@angular/router";
import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../../app.config";
import { DetalhesAssinaturaResponse } from "../arguments/assinatura/DetalhesAssinaturaResponse";
import { interval, Observable, Subject, Subscription } from "rxjs";
import { ItemLookupPlano } from "../../auth/models/item-lookup-plano.model";
import { CadastroUsuarioPlanoRequest } from "../../auth/models/CadastroUsuarioPlanoRequest.model";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";

@Injectable()
export class AssinaturaService implements OnDestroy {
  private trialExpirou = false;
  private trialExpirou$ = new Subject<boolean>();

  private planoplanoAtual!: DetalhesAssinaturaResponse;
  private planoplanoAtual$ = new Subject<DetalhesAssinaturaResponse>();

  private intervaloAtualizacaoPlano$: Subscription; // 30 * 60 * 1000 Intervalo de 30 minutos (em milissegundos)

  private amodireito = false;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.amodireito = this.router.url.indexOf("amoodireito") >= 0;

    this.intervaloAtualizacaoPlano$ = interval(30 * 60 * 1000).subscribe(() => {
      this.carregarPlanoAtual();
    });
  }

  ngOnDestroy(): void {
    this.intervaloAtualizacaoPlano$.unsubscribe();
  }

  public atualizaPlanoAtual() {
    this.carregarPlanoAtual();
  }

  public carregarPlanoAtual(): void {
    const url = `${AppConfig.apiEndpoint}/assinatura/meu-plano`;

    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        const resultado = result[0];

        if (resultado) {
          if (resultado?.trialGratuito) {
            resultado.diasTesteUtilizados =
              resultado?.tempoAvaliacaoGratuita -
              resultado?.diasRestantesAvaliacao;

            if (resultado?.tempoAvaliacaoGratuita <= 0) {
              this.trialExpirou = true;
              this.updateTrialExpirou();
            }
          }
        }
        this.planoplanoAtual = resultado;
        this.updateplanoplanoAtual();
      },
      error: (error) => {
        this.errorHandlerService.handleError(error);
        this.planoplanoAtual = new DetalhesAssinaturaResponse();
        this.updateplanoplanoAtual();
      },
    });
  }

  public listarPlanos(apenasTrial: boolean): ItemLookupPlano[] {
    const planos: ItemLookupPlano[] = [
      { id: 6, descricao: "Teste grátis", periodicidade: "trial" },
      {
        id: 7,
        descricao: this.amodireito
          ? "Cobrança mensal - R$ 21,00 (15% off)"
          : "Cobrança mensal - R$ 24,90",
        periodicidade: "mensal",
      },
      {
        id: 8,
        descricao: this.amodireito
          ? "Cobrança anual - R$ 174,30 (30% off)"
          : "Cobrança anual - R$ 249,00",
        periodicidade: "anual",
      },
    ];

    return planos.filter(
      (p) =>
        (apenasTrial && p.periodicidade === "trial") ||
        p.periodicidade !== "trial"
    );
  }

  public assinarPlano(payload: CadastroUsuarioPlanoRequest) {
    const url = `${AppConfig.apiEndpoint}/assinatura/novo`;

    this.httpClient.post(url, payload).subscribe({
      next: () => {},

      error: (error: any) => {
        this.errorHandlerService.handleError(error);
      },
    });
  }

  public alterarPlano(payload: CadastroUsuarioPlanoRequest) {
    const url = `${AppConfig.apiEndpoint}/assinatura/alterar`;
    this.httpClient.post(url, payload).subscribe({
      next: () => {},

      error: (error: any) => {
        this.errorHandlerService.handleError(error);
      },
    });
  }

  public updateTrialExpirou() {
    this.trialExpirou$.next(this.trialExpirou);
  }

  public getTrialExpirou(): Observable<boolean> {
    return this.trialExpirou$.asObservable();
  }

  public updateplanoplanoAtual() {
    this.planoplanoAtual$.next(this.planoplanoAtual);
  }

  public getplanoplanoAtual(): Observable<DetalhesAssinaturaResponse> {
    return this.planoplanoAtual$.asObservable();
  }
}
